const GROUPED_LINKS_COLUMN_CLASSES_PREFIX = "GroupedLinksColumn";

export const GROUPED_LINKS_COLUMN_CLASSES = {
  headline: `${GROUPED_LINKS_COLUMN_CLASSES_PREFIX}-headline`,
  countrySelector: `${GROUPED_LINKS_COLUMN_CLASSES_PREFIX}-countrySelector`,
};
